// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line[data-v-4e5041f0] {\n  height: 1px;\n  width: 100%;\n  background-color: #ed6c84;\n  /*margin: 0;*/\n}\n.line.bigger[data-v-4e5041f0] {\n  height: 2px;\n}", ""]);
// Exports
module.exports = exports;
